"use client";

import { useEffect, useRef, useState } from "react";
import CountUp from "react-countup";

export default function StatsSection() {
  const ref = useRef(null);
  const [startCount, setStartCount] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setStartCount(true);
        }
      },
      { threshold: 0.4 }
    );

    if (ref.current) observer.observe(ref.current);

    return () => observer.disconnect();
  }, []);

  const stats = [
    { number: 1000, label: "Doctors" },
    { number: 220, label: "Hospitals" },
    { number: 110, label: "Corporates & Associations" },
    { number: 5000, label: "Customers" },
  ];

  return (
    <div
      ref={ref}
      className="mt-[100px] grid grid-cols-2 gap-8 rounded-2xl border border-gray-200 bg-white p-8 shadow-sm lg:grid-cols-4" data-aos="fade-down"
    >
      {stats.map((stat, i) => (
        <div
          key={i}
          className={`text-center transform transition-all duration-700 ${
            startCount
              ? "scale-100 opacity-100 animate-pulse"
              : "scale-75 opacity-0"
          }`}
        >
          <div className="font-display text-3xl font-bold gradient-text2 lg:text-4xl">
            {startCount && (
              <CountUp end={stat.number} duration={2.5} separator="," />
            )}
            +
          </div>

          <div className="mt-1 text-sm text-gray-600">
            {stat.label}
          </div>
        </div>
      ))}
    </div>
  );
}